<div class="bc-page">

  <!-- ============================================================
       HERO
       ============================================================ -->
  <section class="bc-hero">
    <div class="bc-hero-orb bc-orb-cyan"></div>
    <div class="bc-hero-orb bc-orb-gold"></div>

    <div class="bc-container">
      <div class="bc-hero-grid">

        <div class="bc-reveal bc-hidden">
          <div class="bc-eyebrow-row">
            <span class="bc-brand-mark"><span class="bc-dot"></span>Sehyog Academy</span>
            <span class="bc-hero-pill">11+ Summer Bootcamp</span>
          </div>

          <h1 class="bc-hero-title">Crack the pattern.<br><span class="bc-accent-cyan">Own</span> the <span class="bc-accent-gold">exam.</span></h1>

          <p class="bc-hero-sub">Subject-specific revision across four 11+ subjects — eight focused days each, built around the exam boards that matter.</p>

          <div class="bc-boards-row">
            <span class="bc-board-chip">CSSE</span>
            <span class="bc-board-chip">GL</span>
            <span class="bc-board-chip">FSCE</span>
            <span class="bc-board-chip">SET</span>
            <span class="bc-board-chip">ISEB</span>
            <span class="bc-board-date"><i class="ti ti-calendar-event"></i>From 19 July</span>
          </div>

          <div class="bc-hero-actions">
            <button class="bc-btn-book" (click)="scrollToBook()">
              Book Your Place
              <i class="ti ti-arrow-right"></i>
            </button>
            <button class="bc-btn-ghost" (click)="downloadBrochure()">
              Download Brochure
              <i class="ti ti-download"></i>
            </button>
          </div>

          <p class="bc-hero-note"><b>Early bird pricing</b> — ends the moment places fill up</p>
        </div>

        <!-- Signature visual: stacked practice papers -->
        <div class="bc-reveal bc-hidden bc-d1">
          <div class="bc-stack">

            <div class="bc-paper bc-paper-back-2">
              <i class="ti ti-math-symbols bc-paper-corner-icon"></i>
              <div class="bc-paper-line" style="width:70%"></div>
              <div class="bc-paper-line" style="width:50%"></div>
              <div class="bc-paper-line" style="width:60%"></div>
            </div>

            <div class="bc-paper bc-paper-back-1">
              <i class="ti ti-abc bc-paper-corner-icon"></i>
              <div class="bc-paper-line" style="width:65%"></div>
              <div class="bc-paper-line" style="width:80%"></div>
              <div class="bc-paper-line" style="width:45%"></div>
            </div>

            <div class="bc-paper bc-paper-front">
              <span class="bc-float-chip bc-float-1"><b>720+</b><span>Exam Qs</span></span>
              <span class="bc-float-chip bc-float-2"><b>2</b><span>Mock Exams</span></span>

              <p class="bc-pattern-label"><i class="ti ti-shape"></i>A typical NVR question</p>
              <div class="bc-pattern-row">
                <div class="bc-pattern-shape bc-ps-gold"><i class="ti ti-square-filled"></i></div>
                <i class="ti ti-arrow-narrow-right bc-pattern-arrow"></i>
                <div class="bc-pattern-shape bc-ps-cyan"><i class="ti ti-circle-filled"></i></div>
                <i class="ti ti-arrow-narrow-right bc-pattern-arrow"></i>
                <div class="bc-pattern-shape bc-ps-navy"><i class="ti ti-triangle-filled"></i></div>
                <i class="ti ti-arrow-narrow-right bc-pattern-arrow"></i>
                <div class="bc-pattern-shape bc-ps-q">?</div>
              </div>
              <p class="bc-pattern-caption">Spotting it in <span>3 seconds</span> is a skill.</p>
              <p class="bc-pattern-sub">We teach the method behind every VR &amp; NVR question type — not just the answer.</p>
            </div>

          </div>
        </div>

      </div>
    </div>
  </section>

  <!-- ============================================================
       STATS
       ============================================================ -->
  <div class="bc-stats-wrap">
    <div class="bc-container">
      <div class="bc-stats-bar bc-reveal bc-hidden">
        <div class="bc-stat" *ngFor="let s of stats">
          <span class="bc-stat-num">{{ s.num }}</span>
          <span class="bc-stat-label">{{ s.label }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- ============================================================
       SUBJECTS
       ============================================================ -->
  <section class="bc-section bc-subjects-section">
    <div class="bc-container">

      <div class="bc-section-header bc-reveal bc-hidden">
        <p class="bc-eyebrow">What you'll study</p>
        <h2 class="bc-section-title">Four subjects. <em>One method.</em></h2>
        <p class="bc-section-sub">Each subject gets its own 8-day block — deep, focused, and paced for real exam recall.</p>
      </div>

      <div class="bc-subjects-grid">
        <div class="bc-subject-card bc-reveal bc-hidden" *ngFor="let sub of subjects; let i = index" [class]="'bc-d' + (i % 4)">
          <div class="bc-subject-badge" [ngClass]="sub.badgeClass">
            <i class="ti" [ngClass]="sub.icon"></i>
          </div>
          <div class="bc-subject-body">
            <div class="bc-subject-top">
              <span class="bc-subject-name">{{ sub.name }}</span>
              <span class="bc-subject-sessions">{{ sub.sessions }}</span>
            </div>
            <p class="bc-subject-desc">{{ sub.desc }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- ============================================================
       HIGHLIGHTS — bento
       ============================================================ -->
  <section class="bc-section bc-highlights-section">
    <div class="bc-container">

      <div class="bc-section-header bc-center bc-reveal bc-hidden">
        <p class="bc-eyebrow">Course highlights</p>
        <h2 class="bc-section-title">Everything <span class="bc-gold">included</span></h2>
      </div>

      <div class="bc-bento">
        <div class="bc-bento-item bc-reveal bc-hidden" [ngClass]="[item.span, 'bc-d' + (i % 4)]" *ngFor="let item of bentoItems; let i = index">
          <div class="bc-bi-icon" [ngClass]="item.iconClass">
            <i class="ti" [ngClass]="item.icon"></i>
          </div>
          <ng-container *ngIf="item.span !== 'bc-bi-6'; else wideItem">
            <div class="bc-bento-num">{{ item.num }}</div>
            <div class="bc-bento-title">{{ item.title }}</div>
            <p class="bc-bento-text">{{ item.text }}</p>
          </ng-container>
          <ng-template #wideItem>
            <div class="bc-bi-6-body">
              <div class="bc-bento-num bc-bi-6-num">{{ item.num }}</div>
              <p class="bc-bento-text">{{ item.text }}</p>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </section>

  <!-- ============================================================
       FEATURES
       ============================================================ -->
  <section class="bc-section bc-features-section">
    <div class="bc-container">
      <div class="bc-features-inner">

        <div class="bc-features-left bc-reveal bc-hidden">
          <p class="bc-eyebrow">Full package</p>
          <h2 class="bc-section-title">Supportive <em>every step.</em></h2>
          <p class="bc-section-sub">Our Customer Success Team is with you from booking through to results day.</p>
          <div style="margin-top:28px">
            <button class="bc-btn-primary" (click)="scrollToBook()">
              Book Your Place Now
              <i class="ti ti-arrow-right"></i>
            </button>
          </div>
        </div>

        <div class="bc-features-right">
          <div class="bc-feature-item bc-reveal bc-hidden" [class]="'bc-d' + (i % 4)" *ngFor="let f of features; let i = index">
            <div class="bc-feature-icon"><i class="ti" [ngClass]="f.icon"></i></div>
            <div>
              <div class="bc-feature-title">{{ f.title }}</div>
              <p class="bc-feature-text">{{ f.text }}</p>
            </div>
          </div>
        </div>

      </div>
    </div>
  </section>

  <!-- ============================================================
       TESTIMONIAL
       ============================================================ -->
  <section class="bc-section bc-testi-section">
    <div class="bc-container">
      <div class="bc-testi-inner">

        <div class="bc-testi-card bc-reveal bc-hidden">
          <div class="bc-stars">
            <i class="ti ti-star-filled" *ngFor="let s of [1,2,3,4,5]"></i>
          </div>
          <p class="bc-testi-text">The mock tests helped us identify exactly which areas needed work. The result analysis gave us a clear picture week by week — my son secured his place at his chosen grammar school!</p>
          <div class="bc-testi-name">Jaya Rani</div>
        </div>

        <div class="bc-testi-right bc-reveal bc-hidden bc-d1">
          <h2 class="bc-testi-heading">Join <span class="bc-cyan-t">10,000+</span><br>successful <span class="bc-gold-t">students.</span></h2>
          <p class="bc-testi-sub">Sehyog has been guiding students to grammar school success since 2014. Our Bootcamp is rated 5 stars on Trustpilot.</p>
          <button class="bc-btn-book" (click)="scrollToBook()">
            Book Bootcamp Now
            <i class="ti ti-arrow-right"></i>
          </button>
          <div><a class="bc-compare-link" [routerLink]="['/rapid-course']">Compare with Summer Intensive Course <i class="ti ti-arrow-narrow-right"></i></a></div>
        </div>

      </div>
    </div>
  </section>

  <!-- ============================================================
       CONTACT / BOOK
       ============================================================ -->
  <section class="bc-section bc-contact-section" id="bc-book">
    <div class="bc-container">
      <div class="bc-contact-inner">

        <div class="bc-reveal bc-hidden">
          <h2 class="bc-contact-title">Ready to <span class="bc-gold-t">start this summer?</span></h2>
          <p class="bc-contact-sub">Secure your child's place on the 11+ Summer Bootcamp. Limited spaces — bookings fill up fast every year.</p>

          <div class="bc-contact-links">
            <a [href]="link.href" class="bc-contact-link" *ngFor="let link of contactLinks">
              <div class="bc-contact-icon"><i class="ti" [ngClass]="link.icon"></i></div>
              {{ link.label }}
            </a>
          </div>

          <div class="bc-social-row">
            <a class="bc-social-btn" [href]="s.href" [attr.aria-label]="s.label" *ngFor="let s of socialLinks">
              <i class="ti" [ngClass]="s.icon"></i>
            </a>
          </div>
        </div>

        <div class="bc-reveal bc-hidden bc-d2">
          <div class="bc-cta-card">
            <h3 class="bc-cta-heading">Scan to Book</h3>
            <div class="bc-qr-box">
              <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                <rect x="5" y="5" width="35" height="35" fill="none" stroke="#0B4F6C" stroke-width="3"/>
                <rect x="12" y="12" width="21" height="21" fill="#0B4F6C"/>
                <rect x="60" y="5" width="35" height="35" fill="none" stroke="#0B4F6C" stroke-width="3"/>
                <rect x="67" y="12" width="21" height="21" fill="#0B4F6C"/>
                <rect x="5" y="60" width="35" height="35" fill="none" stroke="#0B4F6C" stroke-width="3"/>
                <rect x="12" y="67" width="21" height="21" fill="#0B4F6C"/>
                <rect x="60" y="55" width="7" height="7" fill="#0B4F6C"/>
                <rect x="68" y="55" width="7" height="7" fill="#0B4F6C"/>
                <rect x="76" y="55" width="7" height="7" fill="#0B4F6C"/>
                <rect x="84" y="55" width="7" height="7" fill="#0B4F6C"/>
                <rect x="60" y="63" width="7" height="7" fill="#0B4F6C"/>
                <rect x="76" y="63" width="7" height="7" fill="#0B4F6C"/>
                <rect x="60" y="71" width="7" height="7" fill="#0B4F6C"/>
                <rect x="68" y="71" width="7" height="7" fill="#0B4F6C"/>
                <rect x="84" y="71" width="7" height="7" fill="#0B4F6C"/>
                <rect x="60" y="79" width="7" height="7" fill="#0B4F6C"/>
                <rect x="76" y="79" width="7" height="7" fill="#0B4F6C"/>
                <rect x="60" y="87" width="7" height="7" fill="#0B4F6C"/>
                <rect x="68" y="87" width="7" height="7" fill="#0B4F6C"/>
                <rect x="76" y="87" width="7" height="7" fill="#0B4F6C"/>
                <rect x="84" y="87" width="7" height="7" fill="#0B4F6C"/>
              </svg>
            </div>
            <p class="bc-qr-sub">Scan with your phone camera</p>
            <p class="bc-qr-handle">&#64;SehyogAcademy</p>
          </div>
        </div>

      </div>

      <p class="bc-fine-print">* T&amp;C applies. All session counts are approximate and subject to scheduling. Early bird discount valid while places last.</p>
    </div>
  </section>

</div>
